import { apiV1 } from './api';

const getMessageList = (params = {}) => apiV1.get('/messages', { params });

const archiveMessages = ({ params }) => apiV1.put(`/messages/archive`, params);
const readMessages = ({ params }) => apiV1.put(`/messages/read`, params);

export { getMessageList, archiveMessages, readMessages };
